import { render } from "./SidebarLogo.vue?vue&type=template&id=742fe691&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=js"
export * from "./SidebarLogo.vue?vue&type=script&lang=js"

import "./SidebarLogo.vue?vue&type=style&index=0&id=742fe691&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742fe691"]])

export default __exports__